import script from "./commonPopSwiper.vue?vue&type=script&setup=true&name=commonPopSwiper&lang=js"
export * from "./commonPopSwiper.vue?vue&type=script&setup=true&name=commonPopSwiper&lang=js"

const __exports__ = script;

export default __exports__